export default "__VITE_ASSET__DLChKkeF__"